import { createAction } from "@ngrx/store";

import {
	BalanceLimitExceededRealTimeMessagePayload,
	BettingLimitReachedRealTimeMessagePayload,
	DepositLimitReachedRealTimeMessagePayload,
} from "../real-time-notifications/real-time-notifications.model";

import {
	CustomerLimitAlertPayload,
	CustomerLimitSnackBarPayload,
	SessionLimitNotificationPayload,
} from "./customer-limit-notifications.model";

const ACTION_PREFIX = "[Customer Limit Notifications]";

export namespace CustomerLimitNotificationsAction {
	export const openSnackBar = createAction(
		`${ACTION_PREFIX} Open Snackbar`,
		(snackbarOpts: CustomerLimitSnackBarPayload) => ({ snackbarOpts })
	);

	export const openAlert = createAction(`${ACTION_PREFIX} Open Alert`, (alert: CustomerLimitAlertPayload) => ({
		alert,
	}));

	export const openSessionLimitSnackbar = createAction(
		`${ACTION_PREFIX} Open Session Limit Snackbar`,
		(snackbarOpts: CustomerLimitSnackBarPayload) => ({ snackbarOpts })
	);

	export const openSelfExclusionAlert = createAction(`${ACTION_PREFIX} Open Self Exclusion Alert`);

	export const openSessionExpiryAlert = createAction(
		`${ACTION_PREFIX} Open Session Expiry Alert`,
		(alert: CustomerLimitAlertPayload) => ({ alert })
	);

	export const openSessionLimitNotificationDialog = createAction(
		`${ACTION_PREFIX} Open Session Limit Notification Dialog`,
		(payload: SessionLimitNotificationPayload) => payload
	);

	export const handleSessionLimitNotification = createAction(
		`${ACTION_PREFIX} Handle Session Limit Notification`,
		(payload: SessionLimitNotificationPayload) => payload
	);

	export const openBalanceLimitExceededAlert = createAction(
		`${ACTION_PREFIX} Open Balance Limit Exceeded Alert`,
		(payload: BalanceLimitExceededRealTimeMessagePayload) => payload
	);

	export const openDepositLimitReachedAlert = createAction(
		`${ACTION_PREFIX} Open Deposit Limit Reached Alert`,
		(payload: DepositLimitReachedRealTimeMessagePayload) => payload
	);

	export const openBettingLimitReachedAlert = createAction(
		`${ACTION_PREFIX} Open Betting Limit Reached Alert`,
		(payload: BettingLimitReachedRealTimeMessagePayload) => payload
	);

	export const openSessionLimitReachedAlert = createAction(`${ACTION_PREFIX} Open Session Limit Reached Alert`);
}
